import { AxiosInstance } from 'axios';
import { axiosWithoutCaseMiddleware } from '@/helpers/forms/axios';

export interface orderMapColumnInterface {
    key: string
    title: string
}

export interface orderMapRowInterface {
    [key: string]: string
}

interface mappingDataResponseInterface {
    rows: orderMapRowInterface[]
    columns: orderMapColumnInterface[]
}

export interface UploadMappedOrdersPayload {
    channelId: number
    orders: Record<string, unknown>[]
}

interface UploadMappedOrdersRequest {
    channel_id: number
    orders: Record<string, unknown>[]
}

export default (axios: AxiosInstance = axiosWithoutCaseMiddleware): { fetchUploadMappingData: () => Promise<mappingDataResponseInterface>; uploadMappedOrders: (payload: UploadMappedOrdersPayload) => Promise<void>; } => ({
    fetchUploadMappingData: async (): Promise<mappingDataResponseInterface> => {
        const response = await (await axios.get<mappingDataResponseInterface>('/api/orders/sheetData'));

        return response.data;
    },

    uploadMappedOrders: async (payload: UploadMappedOrdersPayload): Promise<void> => {
        const requestPayload: UploadMappedOrdersRequest = {
            channel_id: payload.channelId,
            orders: payload.orders,
        };

        await axios.post('/api/orders/upload', requestPayload);
    },
});
